import { apiClient } from '@/services/ApiClient.js'

export default {
  checkTaxNumberValidation() {
    return apiClient
      .get('general/check-tax-number-validation')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  getTaxOfficesByCity(cityPlate) {
    return apiClient
      .get('general/cities/' + cityPlate + '/tax-offices')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  validateTaxNumber(taxOfficeNumber, taxNumber) {
    return apiClient
      .get('general/validate-tax-number', {
        params: { tax_number: taxNumber, tax_office_number: taxOfficeNumber }
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
